export default "__VITE_ASSET__CRXovrgU__"